import React from 'react'
import styles from './style.module.css'
function MainLoader({height}) {
  return (
    <div className={styles.mainWrapper} style={{height:height?`${height}vh`:"70vh"}}>
        <span className={styles.mainLoader}></span>
    </div>
  )
}

export default MainLoader